import { Grid, Link, Text } from '@chakra-ui/react';
import React from 'react';
import { ICreatorPlatformStatus } from '~/clientApi';
import {
  ALL_SOCIAL_PLATFORM_TYPE,
  PARTIALLY_SUPPORTED_PLATFORMS,
  SOCIAL_PLATFORMS,
  SOCIAL_PLATFORM_SHORT,
} from '~/constants';
import { getPlatformProfileLink } from '~/core/utils';
import { formatAbbr } from '~/utils';
import { convertPxToRems } from '~/utils-ts';

interface PlatformProps {
  platform?: ICreatorPlatformStatus;
  socialPlatform?: SOCIAL_PLATFORM_SHORT;
}

export const Platform: React.FC<PlatformProps> = ({
  platform,
  socialPlatform,
}) => {
  const getManualCreator = () => {
    if (platform?.status === 'manual') {
      return socialPlatform;
    }
    return platform?.handle ? formatAbbr(platform.followersCount) : '-';
  };

  const getSocialPlatform = () => {
    const socialPlatformMapping = {
      IG: SOCIAL_PLATFORMS.instagram,
      TT: SOCIAL_PLATFORMS.tiktok,
      YT: SOCIAL_PLATFORMS.youtube,
      SC: PARTIALLY_SUPPORTED_PLATFORMS.snapchat,
    };
    return (
      socialPlatformMapping[
        socialPlatform as keyof typeof socialPlatformMapping
      ] || null
    );
  };

  return (
    <div>
      <Grid
        height="100%"
        alignItems="center"
        justifyContent="center"
        minHeight={8}
      >
        {getManualCreator() !== '-' ? (
          <Link
            href={getPlatformProfileLink(
              getSocialPlatform() as ALL_SOCIAL_PLATFORM_TYPE,
              platform?.handle as string,
            )}
            target="_blank"
            textDecoration="none !important"
          >
            <Text
              color="primary.400"
              fontSize="md"
              fontWeight="400"
              lineHeight={convertPxToRems(14)}
            >
              {getManualCreator()}
            </Text>
          </Link>
        ) : (
          <Text
            color="primary.400"
            fontSize="md"
            fontWeight="400"
            lineHeight={convertPxToRems(14)}
          >
            {getManualCreator()}
          </Text>
        )}
      </Grid>
    </div>
  );
};
